import {Table} from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';

function DispenseReport({summary, protocolRunBy, intl, isHumidifierInstalled}) {
  const reportData = summary.map((data) => {
    const styleName = '';
    const tableRow = (
      <tr>
        <td style={{width: '18vw'}} className={styleName}>
          {data.destinationPlateBarcode}
        </td>
        <td style={{width: '18vw'}} className={styleName}>
          {data.destinationPlateName}
        </td>
        <td style={{width: '8vw'}} className={styleName}>
          {data.destinationWell}
        </td>
        <td style={{width: '18vw'}} className={styleName}>
          {data.sourcePlateBarcode}
        </td>
        <td style={{width: '18vw'}} className={styleName}>
          {data.sourcePlateName}
        </td>
        <td style={{width: '8vw'}} className={styleName}>
          {data.sourceWell}
        </td>
        <td style={{width: '8vw'}} className={styleName}>
          {data.transferVolume}
        </td>
        <td style={{width: '8vw'}} className={styleName}>
          {data.number}
        </td>
        <td style={{width: '8vw'}} className={styleName}>
          {data.tips}
        </td>
        <td style={{width: '8vw'}} className={styleName}>
          {data.status}
        </td>
        <td style={{width: '18vw'}} className={styleName}>
          {data.errorCode}
        </td>
        <td style={{width: '18vw'}} className={styleName}>
          {data.start}
        </td>
        <td style={{width: '18vw'}} className={styleName}>
          {data.end}
        </td>
        {isHumidifierInstalled && (
          <>
            <td style={{width: '8vw'}} className={styleName}>
              {data.humidity}
            </td>

            <td style={{width: '8vw'}} className={styleName}>
              {data.temperature}
            </td>
            <td style={{width: '8vw'}} className={styleName}>
              {data.isHumidifierDoorOpened}
            </td>
          </>
        )}
        <td style={{width: '25vw'}} className={styleName}>
          {data.notes}
        </td>
      </tr>
    );

    return tableRow;
  });

  return (
    <div id="dispense-report">
      <div className="report-table-desc">
        <span className="report-table-desc__label">
          {intl.formatMessage({id: 'dispenseReport.label.protocolRunBy'})}
        </span>
        <span className="report-table-desc__colon">:</span>
        <span className="report-table-desc__value">{protocolRunBy}</span>
      </div>
      <Table responsive className="report-table">
        <thead>
          <tr>
            <th style={{width: '18vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.firstColumn'})}
            </th>
            <th style={{width: '18vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.secondColumn'})}
            </th>
            <th style={{width: '8vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.thirdColumn'})}
            </th>
            <th style={{width: '18vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.fourthColumn'})}
            </th>
            <th style={{width: '18vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.fivethColumn'})}
            </th>
            <th style={{width: '8vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.sixthColumn'})}
            </th>
            <th style={{width: '8vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.seventhColumn'})}
            </th>
            <th style={{width: '8vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.eighthColumn'})}
            </th>
            <th style={{width: '8vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.ninthColumn'})}
            </th>
            <th style={{width: '8vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.tenthColumn'})}
            </th>
            <th style={{width: '18vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.eleventhColumn'})}
            </th>
            <th style={{width: '18vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.twelfthColumn'})}
            </th>
            <th style={{width: '18vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.thirteenthColumn'})}
            </th>
            {isHumidifierInstalled && (
              <>
                <th style={{width: '8vw'}} className="report-table-header">
                  {intl.formatMessage({id: 'dispenseReport.tableHeader.fourteenthColumn'})}
                </th>
                <th style={{width: '8vw'}} className="report-table-header">
                  {intl.formatMessage({id: 'dispenseReport.tableHeader.fifteenthColumn'})}
                </th>
                <th style={{width: '8vw'}} className="report-table-header">
                  {intl.formatMessage({id: 'dispenseReport.tableHeader.sixteenthColumn'})}
                </th>
              </>
            )}
            <th style={{width: '25vw'}} className="report-table-header">
              {intl.formatMessage({id: 'dispenseReport.tableHeader.seventeenthColumn'})}
            </th>
          </tr>
        </thead>
        <tbody>{reportData}</tbody>
      </Table>
    </div>
  );
}

export default DispenseReport;

DispenseReport.propTypes = {
  protocolRunBy: PropTypes.string.isRequired,
  summary: PropTypes.array.isRequired,
  intl: PropTypes.any.isRequired,
  isHumidifierInstalled: PropTypes.bool.isRequired,
};
